// Auditoria de Kits de Admissão (Gestão Orçamentária): cruza contratações (Mão de Obra) x Kits
// Admissão lançados (Despesas/Custos Gerais) dos 13 departamentos de uma vez — mesma visão
// executiva restrita do DRE Gerencial/Análise por Departamento (ver
// backend/services/kit_admissao_svc.py).
// Espelha backend/config.py ROLES_AUDITORIA_KITS_ADMISSAO — mantenha os dois em sincronia.
export const ROLES_AUDITORIA_KITS_ADMISSAO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
